/**FAQs for 1st accordian */
// declare var require: any;
// export const faqs1 = require('./faqs1.json');
// /**FAQs for 2nd accordian */
// export const faqs2 = require('./faqs2.json');
/**About the ketto */
export const about_ketto = {
  // tslint:disable-next-line:max-line-length
  about: `Ketto.org is an online crowdfunding platform that supports the treatment of various poor & needy patients especially children. Since many of them are unable to afford their life-saving bills, the power of crowdfunding helps make it happen. Till date, Ketto with the help of 10,00,000+ generous donors like you who contributed towards the medical cause managed to save the lives of 90,000+ patients. We've raised  Rs. 250+ Crore that helped pay for the crucial treatment of patients suffering from Cancer, heart-diseases, Thalassemia, transplants & more.`,
  position: '-10px -245px'
};
export function how_it_works(data) {
  return [
    {
      title: 'Patient seeks care',
      desc: `${data.patient} is brought to one of our medical partners ${data.hospital}`,
      position: '9px -180px'
    },
    {
      title: `Medical Partner submits Patient’s case to Ketto`,
      desc: `${data.beneficiary}’s profile is sent to us. We review and approve the case and start fundraising for ${data.patient}.`,
      position: '9px -380px'
    },
    {
      title: `Donors fund Patient’s care`,
      // tslint:disable-next-line:max-line-length
      desc: `Generous people like you provide generous donations which is provided directly to our medical partner ${data.hospital} for ${data.patient}’s care.`,
      position: '9px -787px'
    },
    {
      title: `Get notified on your Donation Impact`,
      // tslint:disable-next-line:max-line-length
      desc: `Medical Partner ${data.hospital} and Patient’s family provide a post treatment update on ${data.patient} and we send it to his/her donors.`,
      position: '9px -586px'
    },
  ];
}

export function hiw_non_medical(data) {
  return [
    {
      title: 'NGO seeks support',
      desc: `${data.beneficiary} reaches out to us through an ${data.manager}`,
      position: '9px -180px'
    },
    {
      title: `${data.manager} submits NGO’s case to Ketto`,
      desc: `${data.beneficiary}’s profile is sent to us. We review and approve the case after verification. A fundraising for ${data.beneficiary} is started soon after the verification is completed`,
      position: '9px -380px'
    },
    {
      title: `Donors fund the NGO`,
      // tslint:disable-next-line:max-line-length
      desc: `Kind people like you make generous donations which are directly provided to our ${data.beneficiary}.`,
      position: '9px -787px'
    },
    {
      title: `Get notified on your Donation Impact`,
      // tslint:disable-next-line:max-line-length
      desc: `The ${data.beneficiary} provides a thorough update on how they have helped the society and we send it to his/her donors.`,
      position: '9px -586px'
    },
  ];
}
